import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router";
import TaitoraLogo from "../components/brand/TaitoraLogo";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-amber-500/30">
      {/* Navbar */}
      <nav className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <TaitoraLogo variant="product" tone="light" size={32} />
        <div className="flex items-center gap-6">
          <Link to="/login" className="text-sm text-zinc-400 hover:text-zinc-100">Login</Link>
          <Link to="/signup" className="text-sm font-semibold bg-amber-500 text-zinc-950 px-4 py-2 rounded-lg hover:bg-amber-400">Get Started</Link>
        </div>
      </nav>

      {/* Hero */}
      <main className="max-w-6xl mx-auto px-6 pt-20">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-6xl font-extrabold tracking-tight mb-8"
        >
          Learn Faster. Go Deeper.<br />
          <span className="text-amber-400">Outpace the Rest.</span>
        </motion.h1>
        
        <p className="text-xl text-zinc-400 max-w-2xl mb-10 leading-relaxed">
          Don&apos;t just skim AI outputs—visualize them. Turn chats into structured, high-retention architectural maps.
        </p>


        <motion.button
          onClick={() => navigate("/signup")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-amber-500 text-zinc-950 px-8 py-4 rounded-xl font-bold text-lg shadow-[0_0_20px_rgba(217,148,60,0.3)]"
        >
          Start Mapping Free
        </motion.button>
      </main>
    </div>
  );
}
